import {createActions} from 'redux-actions';
import notificationActions from '../user/notifications.actions';

const actions = createActions(
	'UI_RESIZED',
	'UI_MODAL',
	'UI_TOGGLE_USER_MENU',
	'UI_MESSAGE',
	'UI_SHOW_USER_MENU',
	'UI_PICKER_CALLBACK',
	'UI_PICKER_PREFILL',
	'UI_POPUP'
);

const showUserMenu = () => (dispatch, getState) => {
	const {session} = getState();

	document.documentElement.style.setProperty('--window-height', window.innerHeight);

	// menu can open when not logged in on mobile
	if (session.current) {
		dispatch(notificationActions.markAllViewed());
	}
	dispatch(actions.uiShowUserMenu());
};
export default {
	...actions,
	showUserMenu
};



// WEBPACK FOOTER //
// ./src/chrome/ui.actions.js